import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.704 4.708a1 1 0 0 0-1.415-1.415L8 6.585 4.708 3.296a1.001 1.001 0 0 0-1.415 1.415L6.585 8l-3.289 3.292a1.001 1.001 0 0 0 1.415 1.415L8 9.415l3.292 3.289a1.001 1.001 0 0 0 1.415-1.415L9.415 8z"
    }, null, -1)
  ]))]))
}
export default { render: render }